// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryTuningAutomatedExplainListQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  explainIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
  issueId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
  queryIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type QueryTuningAutomatedExplainListQuery = {
  __typename?: "GraphqlQuery";
  getQueryExplains: Array<{
    __typename?: "QueryExplain";
    id: string;
    humanId: string;
    fingerprint: string;
    seenAt: number;
    totalCost?: number | null;
    totalSharedBlksRead?: number | null;
    totalBlkReadTime?: number | null;
    querySample?: {
      __typename?: "QuerySample";
      id: string;
      queryId: string;
      runtimeMs: number;
    } | null;
  }>;
  getIssueWorkbooks: Array<{
    __typename?: "Workbook";
    id: string;
    issueExplainId?: string | null;
    issueExplainFingerprint?: string | null;
  }>;
  getQueryStats: Array<{
    __typename?: "QuerySummaryStats";
    id: string;
    pctOfTotal: number;
  }>;
};

export const QueryTuningAutomatedExplainListDocument = gql`
  query QueryTuningAutomatedExplainList(
    $databaseId: ID!
    $explainIds: [ID!]
    $issueId: ID!
    $startTs: Int!
    $endTs: Int!
    $queryIds: [ID!]
  ) {
    getQueryExplains(databaseId: $databaseId, explainIds: $explainIds) {
      id
      humanId
      fingerprint
      seenAt
      totalCost
      totalSharedBlksRead
      totalBlkReadTime
      querySample {
        id
        queryId
        runtimeMs
      }
    }
    getIssueWorkbooks(databaseId: $databaseId, issueId: $issueId) {
      id
      issueExplainId
      issueExplainFingerprint
    }
    getQueryStats(
      databaseId: $databaseId
      startTs: $startTs
      endTs: $endTs
      queryIds: $queryIds
    ) {
      id
      pctOfTotal
    }
  }
`;

/**
 * __useQueryTuningAutomatedExplainListQuery__
 *
 * To run a query within a React component, call `useQueryTuningAutomatedExplainListQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryTuningAutomatedExplainListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryTuningAutomatedExplainListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      explainIds: // value for 'explainIds'
 *      issueId: // value for 'issueId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *      queryIds: // value for 'queryIds'
 *   },
 * });
 */
export function useQueryTuningAutomatedExplainListQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryTuningAutomatedExplainListQuery,
    QueryTuningAutomatedExplainListQueryVariables
  > &
    (
      | {
          variables: QueryTuningAutomatedExplainListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryTuningAutomatedExplainListQuery,
    QueryTuningAutomatedExplainListQueryVariables
  >(QueryTuningAutomatedExplainListDocument, options);
}
export function useQueryTuningAutomatedExplainListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryTuningAutomatedExplainListQuery,
    QueryTuningAutomatedExplainListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryTuningAutomatedExplainListQuery,
    QueryTuningAutomatedExplainListQueryVariables
  >(QueryTuningAutomatedExplainListDocument, options);
}
// @ts-ignore
export function useQueryTuningAutomatedExplainListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryTuningAutomatedExplainListQuery,
    QueryTuningAutomatedExplainListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryTuningAutomatedExplainListQuery,
  QueryTuningAutomatedExplainListQueryVariables
>;
export function useQueryTuningAutomatedExplainListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTuningAutomatedExplainListQuery,
        QueryTuningAutomatedExplainListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryTuningAutomatedExplainListQuery | undefined,
  QueryTuningAutomatedExplainListQueryVariables
>;
export function useQueryTuningAutomatedExplainListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTuningAutomatedExplainListQuery,
        QueryTuningAutomatedExplainListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryTuningAutomatedExplainListQuery,
    QueryTuningAutomatedExplainListQueryVariables
  >(QueryTuningAutomatedExplainListDocument, options);
}
export type QueryTuningAutomatedExplainListQueryHookResult = ReturnType<
  typeof useQueryTuningAutomatedExplainListQuery
>;
export type QueryTuningAutomatedExplainListLazyQueryHookResult = ReturnType<
  typeof useQueryTuningAutomatedExplainListLazyQuery
>;
export type QueryTuningAutomatedExplainListSuspenseQueryHookResult = ReturnType<
  typeof useQueryTuningAutomatedExplainListSuspenseQuery
>;
export type QueryTuningAutomatedExplainListQueryResult = Apollo.QueryResult<
  QueryTuningAutomatedExplainListQuery,
  QueryTuningAutomatedExplainListQueryVariables
>;
